const defaultConfig = {
  adultYears: 16,
  alternativeSites: {
    IE: {
      label: 'easycare.specsavers.ie',
      url: 'https://easycare.specsavers.ie',
    },
    UK: {
      label: 'easycare.specsavers.co.uk',
      url: 'https://easycare.specsavers.co.uk',
    },
  },
};

export default { ...defaultConfig, ...window.clssConfig };
